module.exports = __webpack_public_path__ + "img/Download.9c485a5a.svg";